import { render, staticRenderFns } from "./side-by-side-row-lvl1-direct-goals.vue?vue&type=template&id=0411615c"
import script from "./side-by-side-row-lvl1-direct-goals.vue?vue&type=script&lang=js"
export * from "./side-by-side-row-lvl1-direct-goals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports